import { unlistenerFunction } from "./types/unlistenerFunction";

export function triggerUnlistener(unlistener: unlistenerFunction | null) {
  if (unlistener) {
    unlistener();
  }
}
